import JsonFormsWrapper from '@/components/common/jsonForms/jsonFormsWrapper/JsonFormsWrapper'
import {dateJsonSchema, dateUiSchema} from '@/services/MockData/Order/OrderSoldTo/GenralInfJSON'
import {discountPromJsonSchema, discountPromUiSchema} from '@/services/MockData/Order/OrderSoldTo/StoreAddJSON'
import {CustStoreJSONSchema, CustStoreJSONUiSchema} from '@/services/MockData/Order/OrderSoldTo/CustStoreJSON'
import {PageContainer} from '@/components/organisms'
import {AddressField, SectionTitle} from '@/components/molecules'

const OrderSoldToPage = ({OrderDetails}) => {
  // Destructure OrderDetails for easier access
  const {
    createdDateTime,
    subTotal,
    invoiceDateTime,
    orderType,
    orderLocationId,
    sourceOrderId,
    routeId,
    routeTypeId,
    routeSalesRepWorkForceId,
  } = OrderDetails

  // Helper component to render each section with JsonFormsWrapper
  const RenderSection = ({id, label, jsonSchema, uiSchema, data}) => (
    <div>
      <SectionTitle isBorderVisible={true} id={id} label={label} />
      <div className="pt-5">
        <JsonFormsWrapper jsonschema={jsonSchema} uischema={uiSchema} data={data} />
      </div>
    </div>
  )

  return (
    <PageContainer>
      {/* General Information Section */}
      <RenderSection
        id="general_info"
        label="General Information"
        jsonSchema={dateJsonSchema}
        uiSchema={dateUiSchema}
        data={{
          storeID: createdDateTime,
          customerName: subTotal,
          nickname: invoiceDateTime,
          storeName: invoiceDateTime,
          customerUniqId: invoiceDateTime,
          idNumber: invoiceDateTime,
        }}
      />

      {/* Location Section */}
      <AddressField text="123, Path, Yavuztürk MH. Tarih Caddesi No: 121, Üsküdar, Turkey" isIconVisible={false} />
      <div className="pt-5">
        <JsonFormsWrapper
          jsonschema={discountPromJsonSchema}
          uischema={discountPromUiSchema}
          data={{
            parentMemberId: orderType,
            locate: orderLocationId,
            eDOFlag: sourceOrderId,
          }}
        />
      </div>

      {/* Customer & Location Details Section */}
      <RenderSection
        id="customer_location_details"
        label="Customer & Location Details"
        jsonSchema={CustStoreJSONSchema}
        uiSchema={CustStoreJSONUiSchema}
        data={{
          orderLocationId: routeId,
          customerGTMU: routeTypeId,
          countryISOCode: routeSalesRepWorkForceId,
        }}
      />
    </PageContainer>
  )
}

export default OrderSoldToPage
